// Japanese (ja-JP)
export default {
	title: "支払方法",
	tips: "お客様へ、ERC20/TRC20アドレスを入力してください。銀行口座の詳細やパスワードは入力しないでください",
	form: {
		TransactionPassword: "取引パスワード",
		Address: "ウォレットアドレス"
	},
	label: ["銀行名", "支店コード", "支店名", "預金種目", "口座番号", "口座名義"],
	tabs: ["銀行カード", "ネットワーク"],
	delete: "削除",
	default: "デフォルト",
	create: "作成",
	type: "引き出しタイプ",
	verifying: "確認中",
	VerifyWalletAddress: "ウォレットアドレスを確認する",
	defaultAccount: "デフォルト引き出し口座",
	deleteMsg: "本当に削除してもよろしいですか？"
};
